"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.projectScope = exports.projectInternalScope = exports.preFilterScope = exports.parseProjectScope = exports.internalScope = exports.featureScope = exports.clientApplicationScope = void 0;
const operationSeparator = ",";
const scopeSeparator = " ";
const projectScope = permissions => {
  return permissions.map(p => {
    const operations = p.operations.join(operationSeparator);
    return `${p.projectID}:${p.resourceType}:${p.resourceID}=${operations}`;
  }).join(scopeSeparator);
};
exports.projectScope = projectScope;
const projectInternalScope = permissions => {
  return permissions.map(p => {
    const operations = p.operations.join(operationSeparator);
    return `@project:${p.projectID}:${p.resourceType}:${p.resourceID}=${operations}`;
  }).join(scopeSeparator);
};
exports.projectInternalScope = projectInternalScope;
const parseProjectScope = scope => {
  return scope.split(" ").map(s => {
    const trimmed = s.replace("@project:", "");
    const permission = trimmed.split("=", 2);
    if (permission.length !== 2) {
      throw Error(`invalid scope format: ${s}`);
    }
    const operations = permission[1].split(",");
    const instanceID = permission[0].split(":", 3);
    if (instanceID.length !== 3) {
      throw Error(`invalid scope format: ${s}`);
    }
    return {
      projectID: instanceID[0],
      resourceType: instanceID[1],
      resourceID: instanceID[2],
      operations
    };
  });
};
exports.parseProjectScope = parseProjectScope;
const internalScope = permissions => {
  return permissions.map(p => {
    const operations = p.operations.join(operationSeparator);
    return `@internal:${p.resourceType}=${operations}`;
  }).join(scopeSeparator);
};
exports.internalScope = internalScope;
const featureScope = permissions => {
  return permissions.map(p => `${p.projectID}:${p.featureID}`).join(scopeSeparator);
};
exports.featureScope = featureScope;
const clientApplicationScope = permissions => {
  return permissions.map(p => `${p.projectID}:${p.clientApplicationID}`).join(scopeSeparator);
};
exports.clientApplicationScope = clientApplicationScope;
const preFilterScope = (owned, required) => {
  const ownedArr = owned.split(scopeSeparator);
  const requiredArr = required.split(scopeSeparator);
  const trimNegative = instance => {
    if (instance.startsWith("!")) {
      return instance.substring(1);
    }
    return instance;
  };
  const matchInstancePrefix = (o, r, prefix) => trimNegative(o).startsWith(prefix) && trimNegative(r).startsWith(prefix);
  const matchInstance = (o, s) => {
    const instanceO = trimNegative(o);
    const instanceR = trimNegative(s);
    if (matchInstancePrefix(instanceO, instanceR, "@project:")) {
      const [, projectID] = instanceO.split(":", 2);
      const [, requiredProjectID] = instanceR.split(":", 2);
      return projectID === requiredProjectID || projectID === "*" || requiredProjectID === "?";
    }
    if (matchInstancePrefix(instanceO, instanceR, "@")) {
      const [prefix] = instanceO.split(":", 2);
      const [requiredPrefix] = instanceR.split(":", 2);
      return prefix === requiredPrefix;
    }
    const [projectID] = instanceO.split(":", 2);
    const [requiredProjectID] = instanceR.split(":", 2);
    return projectID === requiredProjectID || projectID === "*" || requiredProjectID === "?";
  };
  return ownedArr.filter(o => requiredArr.some(r => matchInstance(o, r))).join(scopeSeparator);
};
exports.preFilterScope = preFilterScope;
//# sourceMappingURL=scope.js.map